import { render, staticRenderFns } from "./CarrouselInformativa.vue?vue&type=template&id=d4747f5e&scoped=true&"
import script from "./CarrouselInformativa.vue?vue&type=script&lang=ts&"
export * from "./CarrouselInformativa.vue?vue&type=script&lang=ts&"
import style0 from "./CarrouselInformativa.vue?vue&type=style&index=0&id=d4747f5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4747f5e",
  null
  
)

export default component.exports